import {
  PayrollConceptsDocument,
  UpdateConceptDocument,
  UpdateConceptMutation,
  UpdateConceptMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export type UpdateConceptPayload = UpdateConceptMutation['payrollMutations']['updatePayrollConcept']

export const useUpdateConcept = () => {
  const [UpdateConcept, { loading }] = useMutation(UpdateConceptDocument, {
    extractorFn: (data: UpdateConceptMutation) => data.payrollMutations.updatePayrollConcept,
    refetchQueries: [PayrollConceptsDocument],
  })

  return {
    loading,
    updateConcept(variables: UpdateConceptMutationVariables) {
      return UpdateConcept({
        variables,
      })
    },
  }
}
